/**
 * OperatorsPage.tsx — Admin operators management page (stub)
 *
 * Purpose:
 *   Lists operator accounts with role assignments and access controls.
 *   Stub implementation — full data-fetching in a subsequent ATP.
 *
 * @module packages/billing-admin/src/pages/OperatorsPage
 * @since 2026-05-31 (AT-50.01 — Scaffold Admin Console UI Foundation)
 */
import React from 'react';
import AdminLayout from '../components/AdminLayout';

/**
 * OperatorsPage — operator account management.
 *
 * @since 2026-05-31 (AT-50.01)
 */
export default function OperatorsPage(): React.JSX.Element {
  return (
    <AdminLayout title="Operators">
      <div className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">Operators</h2>
        <p className="text-sm text-gray-500">Full implementation in subsequent ATP.</p>
      </div>
    </AdminLayout>
  );
}
